import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import ReferBanner from './ReferBanner';

/**
 * @typedef {import("@prismicio/client").Content.RefBannerSlice} RefBannerSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<RefBannerSlice>} RefBannerProps
 * @param { RefBannerProps }
 */
const RefBanner = ({ slice }) => {
  return <ReferBanner slice={slice} />;
};

export default RefBanner;
